import { render, staticRenderFns } from "./LableAmt.vue?vue&type=template&id=8bfa366c"
import script from "./LableAmt.vue?vue&type=script&lang=js"
export * from "./LableAmt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports